export default {"src":"/_next/static/media/primary-school-icon.f261b42d.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};